import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
//import { enablePushNotifications } from "./services/pushNotifications";

import App from "./App";

//console.log('current URL 👉️5', window.location.href);
ReactDOM.render(
	<CssBaseline>
		<App />
	</CssBaseline>,
	document.getElementById("root")
);

// Registrar Service Worker
/* if ("serviceWorker" in navigator) {
	window.addEventListener("load", () => {
		navigator.serviceWorker
			.register("/push-service-worker.js")
			.then(registration => {
				console.log("Service Worker registrado:", registration);
			})
			.catch(error => {
				console.error("Error registrando Service Worker:", error);
			});
	});
} */

// ReactDOM.render(
// 	<React.StrictMode>
// 		<CssBaseline>
// 			<App />
// 		</CssBaseline>,
//   </React.StrictMode>

// 	document.getElementById("root")
// );
